import { CommandService } from "Service/CommandService";
import { BaseService } from "Service/BaseService";
import { Configuration } from "Configuration";

import { GlobalSearchParameter, GlobalSearch, GlobalSearchClient } from "./Client";

/**
 * Service for global search.
 * @hidden
 */
export class GlobalSearchService extends BaseService {
    /**
     * Export a grid to excel.
     * @param gridId Grid ID.
     * @param filterId Filter ID.
     * @param textBlockCategory TextBlockCategory.
     * @param commandOption CommandOption.
     */
    public search(searchText: string, parameters: string, url: string): Promise<GlobalSearch[]> {
        let param: GlobalSearchParameter = {
            Text: searchText,
            CurrentParameters: parameters,
            CurrentUrl: url,
        };
        param = $.extend(param, CommandService.getPageTokenParameter());

        let client = new GlobalSearchClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        return new Promise<GlobalSearch[]>((resolve, reject) => {
            /* let xhr =*/ client.post(
                param,
                (res) => {
                    resolve(res.Value);
                },
                (exception, reason) => {
                    reject(reason);
                }
            );
            // token.onCancelled((reason) => {
            //     xhr.abort();
            //     reject(reason);
            // });
        });
    }
}
